import { FC } from "react";
import { useSelector } from "react-redux";

import { bandSettingsSelector } from "Bands/state";
import { IIconBandSetting } from "Bands/types";
import { copy } from "shared/assets";
import { Card } from "shared/components";
import { IDataKeys } from "shared/types";
import { EditTable } from "../components";

const settingsCopy = copy.bandSettings.eventSettings.type;

export const EditEventType: FC = () => {
  const initialItems = useSelector(bandSettingsSelector<IIconBandSetting>(IDataKeys.eventTypes));

  return (
    <Card title={settingsCopy.edit}>
      <EditTable
        name="eventTypes"
        initialItems={initialItems}
        hasDragAndDrop={true}
        hasIcon={true}
        addCopy={settingsCopy.add}
        dataKey={IDataKeys.eventTypes}
        modalTitle={settingsCopy.modalTitle}
        modalMessage={settingsCopy.modalMessage}
      />
    </Card>
  );
};
